// extracted by mini-css-extract-plugin
module.exports = {"card":"HighlightedCard_card__NQqFJ"};